/* Contexts */
import useAuth from "./useAuth";
/* API Context */
import {axiosBase} from "../api/fetchWrapper";
import {safeJwtDecode} from "../helper/jwtHelper";


export default function useRefreshToken() {
    const { auth, setAuth } = useAuth();
    const REFRESH_URL = '/api-v1/token/refresh';

    const refresh = async (refreshToken) => {
        const oldRefreshToken = localStorage.getItem('old_refresh_token');

        let response = null;
        if (refreshToken) {
            response = await axiosBase.post(REFRESH_URL,
                { refresh_token: refreshToken, old_refresh_token: oldRefreshToken },
                { withCredentials: false }
            );
        } else {
            response = await axiosBase(REFRESH_URL, { withCredentials: true });
        }

        const decodedToken = safeJwtDecode(response.data.token);

        if (!decodedToken) {
            throw new Error('Token invalide reçu du serveur');
        }

        const roles = decodedToken.roles;

        const authData = {
            ...auth,
            roles,
            username: decodedToken.username,
            token: response.data.token,
            agency: decodedToken.agency,
            agency_logo: decodedToken.agency_logo,
            network: decodedToken.network
        };

        setAuth(authData);
        return response.data.token;
    }
    return refresh;
}
